import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { navigate } from "gatsby";
import * as React from "react";
import { SearchWrap } from "./searchbox.elements";
import UserSearchInput from "../UserComponents/SearchInput";
import UserSearchResults from "../UserComponents/SearchResults";
import { SearchService } from "../../services/SearchIndex";
export var SearchBox = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SearchBox, _React$Component);

  function SearchBox(a) {
    var _this;

    _this = _React$Component.call(this, a) || this, _this.querySearchResults = debounce( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(a) {
        var b;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (a) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", void _this.setState({
                  loading: !1,
                  results: []
                }));

              case 2:
                _this.setState({
                  loading: !0
                });

                _context.prev = 3;
                _context.next = 6;
                return _this._searchIndex.search(a);

              case 6:
                b = _context.sent;

                if (!(_this.state.query !== a)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return");

              case 9:
                Array.isArray(b) ? _this.setState({
                  results: b
                }) : b.message && _this.setState({
                  indexError: !0
                });

              case 10:
                _context.prev = 10;
                _this.state.query === a && _this.setState({
                  loading: !1
                });
                return _context.finish(10);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3,, 10, 13]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), 250, !0), _this.onSearch = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(a) {
        var b;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                b = a.target.value;
                _this.setState({
                  query: b
                }), _this.querySearchResults(b);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.onClearIconClick = function () {
      _this.setState({
        query: "",
        results: []
      });
    }, _this.onToggleSearchResults = function (a) {
      _this.setState({
        showSearchResults: a
      });
    }, _this.handleKeyDown = function (a) {
      if (27 === a.keyCode && (_this.onClearIconClick(), a.target.blur()), 40 === a.keyCode && (_this.setState({
        activeItemIdx: Math.min(_this.state.activeItemIdx + 1, _this.state.results.length - 1)
      }), a.preventDefault()), 38 === a.keyCode && (_this.setState({
        activeItemIdx: Math.max(0, _this.state.activeItemIdx - 1)
      }), a.preventDefault()), 13 === a.keyCode) {
        var _a = _this.state.results[_this.state.activeItemIdx];
        _a && navigate(_a.link);
      }
    };
    _this.state = {
      isSearchShown: !1,
      showSearchResults: !1,
      isSearchBoxShown: !1,
      query: "",
      results: [],
      indexError: !1,
      loading: !1,
      activeItemIdx: -1
    };
    return _this;
  }

  var _proto = SearchBox.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._searchIndex = new SearchService(), this._searchIndex.init(process.env.REDOCLY_PREFIX_PATHS);
  };

  _proto.render = function render() {
    var a = this.props.className,
        _this$state = this.state,
        b = _this$state.showSearchResults,
        c = _this$state.results,
        d = _this$state.loading,
        e = _this$state.query,
        f = _this$state.indexError,
        g = _this$state.activeItemIdx;
    return /*#__PURE__*/React.createElement(SearchWrap, {
      className: a
    }, /*#__PURE__*/React.createElement(UserSearchInput, {
      onChange: this.onSearch,
      onToggleSearchResults: this.onToggleSearchResults,
      onKeyDown: this.handleKeyDown,
      onClear: this.onClearIconClick,
      query: e || "",
      loading: d,
      location: this.props.location
    }), /*#__PURE__*/React.createElement(UserSearchResults, {
      show: b,
      results: c,
      indexError: f,
      query: e,
      loading: d,
      activeItemIdx: g,
      location: this.props.location
    }));
  };

  return SearchBox;
}(React.Component);
export function debounce(a, b, c) {
  var d,
      e = 0;
  return function () {
    for (var _len = arguments.length, f = new Array(_len), _key = 0; _key < _len; _key++) {
      f[_key] = arguments[_key];
    }

    function g() {
      1 < e && a.apply(void 0, f), e = 0, d = null;
    }

    e++, d ? clearTimeout(d) : c && a.apply(void 0, f), d = setTimeout(g, b);
  };
}